import { Fragment } from 'react';
import { useDialog } from './hook/useDialog';
import { Section } from './component/Section';
import { SectionCard } from './component/SectionCard';
import { SectionHeader } from './component/SectionHeader';
import { util } from './util';
import { Card } from './component/Card';
import { Button } from './component/Button';
import { Touchable } from './component/Touchable';
import { useTheme } from './hook/useTheme';
import { useList } from './hook/useList';
import { useForm } from './hook/useForm';
import { Box } from './component/Box';
import { toast } from './toast';
import { App } from './component/App';
import { Overlay } from './component/Overlay';
import { LayoutHeader } from './component/LayoutHeader';
import { LayoutSidebar } from './component/LayoutSidebar';
import { LayoutContent } from './component/LayoutContent';
import { LayoutSidebarToggle } from './component/LayoutSidebarToggle';
import { useLayout } from './hook/useLayout';
import { createGlobalState } from './store/createGlobalState';
import { useDevice } from './hook/useDevice';
import { useInput } from './hook/useInput';
export var XR = {
    Fragment: Fragment,
    App: App,
    Box: Box,
    Button: Button,
    Card: Card,
    LayoutContent: LayoutContent,
    LayoutHeader: LayoutHeader,
    LayoutSidebar: LayoutSidebar,
    LayoutSidebarToggle: LayoutSidebarToggle,
    Overlay: Overlay,
    Section: Section,
    SectionCard: SectionCard,
    SectionHeader: SectionHeader,
    Touchable: Touchable,
    useDevice: useDevice,
    useDialog: useDialog,
    useTheme: useTheme,
    useLayout: useLayout,
    useList: useList,
    useForm: useForm,
    useInput: useInput,
    toast: toast,
    util: util,
    createGlobalState: createGlobalState,
};
